// IANA time zone helpers for the store time zone select.
//
// The store's `time_zone` drives the backend's quiet hours and its local-time
// daily jobs, so the value must be an IANA identifier the backend's TZInfo
// list accepts. Intl's list is canonical-only, may name a zone differently
// from a saved value or the browser's resolved zone (e.g. "Europe/Kiev" vs
// "Europe/Kyiv"), and may omit "UTC".

export const getBrowserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
};

const supportedTimeZones = () => {
  try {
    if (typeof Intl.supportedValuesOf === "function") {
      return Intl.supportedValuesOf("timeZone");
    }
  } catch {
    // Runtime without the timeZone key: the options are UTC plus the extras.
  }
  return [];
};

// The runtime's zones plus UTC, sorted. Any `extra` zones (the store's saved
// zone, CreateStore's browser pre-fill) are added so a controlled <select>
// holding one of them shows it instead of silently falling to the first option.
export const getTimeZoneOptions = (...extra) => {
  const zones = new Set(supportedTimeZones());
  zones.add("UTC");
  for (const zone of extra) {
    if (zone) zones.add(zone);
  }
  return [...zones].sort();
};

export const timeZoneLabel = (zone) => zone.replaceAll("_", " ");
